import { z } from "zod";
/** Roadmap v2.0 Tier 1 site package identifiers. */
export const SitePackageIdSchema = z.enum([
    "package-one-page",
    "package-basic-3",
    "package-standard-5",
    "package-growth-8",
    "package-authority-10",
    "package-authority-15",
]);
/** Tier 1 packages allowed in Roadmap v2.0 build scope. */
export const TIER1_SITE_PACKAGE_IDS = [
    "package-one-page",
    "package-basic-3",
    "package-standard-5",
];
/** Tier 2 packages — unlocked when profile richness meets package minimum. */
export const TIER2_SITE_PACKAGE_IDS = [
    "package-growth-8",
    "package-authority-10",
    "package-authority-15",
];
/** @deprecated Use TIER2_SITE_PACKAGE_IDS + richness gate — kept empty after Tier 2 build. */
export const ROADMAP_BLOCKED_SITE_PACKAGE_IDS = [];
export const SiteRouteIdSchema = z.enum([
    "home",
    "services",
    "services-overview",
    "contact",
    "about",
    "service-areas",
    "service-detail-1",
    "service-detail-2",
    "service-detail-3",
    "service-detail-4",
    "service-detail-5",
    "service-detail-6",
    "gallery",
    "location-1",
    "location-2",
    "location-3",
]);
export const SiteRouteDefinitionV1Schema = z
    .object({
    routeId: SiteRouteIdSchema,
    path: z.string().min(1),
    pageTitle: z.string().min(1),
})
    .strict();
export const SurfaceRecipeReferenceV1Schema = z
    .object({
    recipeId: z.string().min(1),
    sectionRoles: z.array(z.string().min(1)).default([]),
})
    .strict();
export const SitePackageDefinitionV1Schema = z
    .object({
    schemaVersion: z.literal("site-package-definition.v1.0"),
    sitePackageId: SitePackageIdSchema,
    displayName: z.string().min(1),
    routes: z.array(SiteRouteDefinitionV1Schema).min(1),
    recipeReferences: z.array(SurfaceRecipeReferenceV1Schema).default([]),
    tier1Allowed: z.boolean(),
    tier2Allowed: z.boolean().default(false),
    roadmapBlocked: z.boolean().default(false),
})
    .strict();
/** Packages that emit multiple route HTML artifacts on export. */
export function isMultiPageExportPackage(sitePackageId) {
    return sitePackageId !== "package-one-page";
}
export const ResolvedSitePackagePlanV1Schema = z
    .object({
    schemaVersion: z.literal("resolved-site-package-plan.v1.0"),
    sitePackageId: SitePackageIdSchema,
    routes: z.array(SiteRouteDefinitionV1Schema),
    recipeReferences: z.array(SurfaceRecipeReferenceV1Schema),
    resolvedAt: z.string().datetime(),
    policyVersion: z.string().min(1),
})
    .strict();
//# sourceMappingURL=site-package.js.map